module.exports = __webpack_public_path__ + "static/5a22d420c9a5a7.416105621512231968826-05410a1d7d8f32f2bbd8299024bceedb.png";